import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link, useParams, Navigate } from 'react-router-dom';
import FuncionariosService from '../../../../../services/funcionarios';
import CargosService from '../../../../../services/cargos';

const Funcionario = () => {
    let { id } = useParams()
    const [nome, setNome] = useState("");
    const [cpf, setCPF] = useState("");
    const [matricula, setMatricula] = useState("");
    const [email, setEmail] = useState("");
    const [cargo, setCargo] = useState("");
    const [situacao, setSituacao] = useState("");
    const [cargos, setCargos] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [redirect, setRedirect] = useState(false);

    async function fetchFuncionarios(id) {
        await fetchCargos()
        const response = await FuncionariosService.funcEdit(id);
        setNome(response.data["nome"]);
        setCPF(String(response.data["cpf"] || ""));
        setMatricula(response.data["matricula"]);
        setEmail(response.data["email"]);
        setSituacao(response.data["situacao"]);
        setCargo(response.data["cargo"]);
    }

    async function fetchCargos() {
        const response = await CargosService.listar();
        if (response.data.length >= 1) {
            setCargos(response.data);
        } else {
            setCargos([]);
        }
    }

    useEffect(() => {
        fetchFuncionarios(id);
    }, [id]);

    function mascararCPF(cpf) {
        if (!cpf) return "";
        cpf = String(cpf).replace(/\D/g, ""); // <-- garante string
        if (cpf.length <= 3) return cpf;
        if (cpf.length <= 6) return cpf.replace(/(\d{3})(\d{1,3})/, "$1.$2");
        if (cpf.length <= 9) return cpf.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
    }

    function normalizarCPF(cpf) {
        return cpf.replace(/\D/g, "");
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const func = await FuncionariosService.editar(id, {
                nome: nome,
                matricula: matricula,
                cpf: normalizarCPF(cpf),
                email: email,
                situacao: situacao,
                cargo: cargo
            })
            if (func.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (sucesso && !redirect) {
        setTimeout(() => {
            setRedirect(true);
        }, 3000); // 3 segundos
    }

    // Quando redirect virar true → redireciona
    if (redirect) {
        return <Navigate to="/rh/funcionarios/listar" />;
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={12}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={12} lg={3}>
                                <Col xs={12} lg={10}>
                                    <Form.Group className="mb-3" controlId="nome">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="matricula">
                                        <Form.Label>Matrícula</Form.Label>
                                        <Form.Control
                                            required
                                            type="number"
                                            name="matricula"
                                            value={matricula}
                                            onChange={e => setMatricula(e.target.value)} />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId="CPF">
                                        <Form.Label>CPF</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="cpf"
                                            value={mascararCPF(cpf)}
                                            onChange={(e) => {
                                                // remove tudo que não for número
                                                const apenasNumeros = e.target.value.replace(/\D/g, "");
                                                if (apenasNumeros.length > 11) {
                                                    apenasNumeros = apenasNumeros.slice(0, 11);
                                                }
                                                setCPF(apenasNumeros);
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group controlId="selectSituacao">
                                        <Form.Label>Situação</Form.Label>
                                        <Form.Select required value={situacao} onChange={e => setSituacao(e.target.value)}>
                                            <option value={situacao}>{situacao}</option>
                                            <option value="Ativo">Ativo</option>
                                            <option value="Demitido">Demitido</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <Form.Group controlId="selectCargo">
                                        <Form.Label>Cargo</Form.Label>
                                        <Form.Select required value={cargo} onChange={e => setCargo(e.target.value)}>
                                            <option value={cargo}>{cargo}</option>
                                            {cargos.map(carg => (
                                                <option key={carg.cargo} value={carg.cargo}>{carg.cargo}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="Email">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row xs={12}>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" type="submit">
                                        Salvar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/rh/funcionarios/listar'}>
                        <Button variant="danger" type="button">
                            Cancelar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>
                        Funcionário editado com sucesso!<br />
                        Redirecionando em 3 segundos...
                    </Alert>
                </Container>
            </Fragment>
        )
    }
}

export default Funcionario;